export const env = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:5000/api/v1',
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
};

export { welcomeEmailConfig, isWelcomeEmailConfigured, welcomeEmailHelper } from './welcomeEmail';

export const hasGoogleMaps = () => Boolean(env.googleMapsApiKey);
